/* @ngInject */
function SharedPackStatusController ($translate) {
  const ctrl = this

  ctrl.formatPackStatus = function () {
    if (!ctrl.status) {
      return
    }

    switch (ctrl.status) {
      case 'READY_TO_DOWNLOAD':
        ctrl.color = 'ready-to-download'
        return $translate.instant('readyToDownload')
      case 'EXPIRES_SOON':
        ctrl.color = 'expires-soon'
        return $translate.instant('expiresSoon')
      case 'EXPIRED':
        ctrl.color = 'expired'
        return $translate.instant('expired')
    }
  }
}

export { SharedPackStatusController }
